import React from 'react';
import { useBrandLogo } from '../contexts/BrandLogoContext';

const BrandLogo = ({ className = "w-auto object-contain", style = { height: '43px' }, alt = "Eptral.Hospital Logo", onClick, ...props }) => {
  const { brandLogo, DEFAULT_LOGO } = useBrandLogo();
  return (
    <img
      src={brandLogo}
      alt={alt}
      className={className}
      style={style}
      onClick={onClick}
      onError={(e) => {
        if (e.target.src !== DEFAULT_LOGO) {
          e.target.onerror = null;
          e.target.src = DEFAULT_LOGO;
        }
      }}
      {...props}
    />
  );
};

export default BrandLogo;
